import React from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-bootstrap';
import {saveVideoContent} from '../../../../actions/content';
import './styles.css';

class VideoEditor extends React.Component {
  state = {
    identifier: '',
    videoURL: '',
  };
  onSubmit = () => {
    const {identifier, onContentSaved} = this.props;
    this.props.dispatch(saveVideoContent(identifier, this.state.videoURL))
      .then(() => {
        onContentSaved();
      });
  };
  updateUrl = (event) => {
    this.setState({
      videoURL: event.target.value
    });
  };
  renderVideoInput = () => {
    const {videoURL} = this.state;
    return (
      <div>
        <input defaultValue={videoURL} onChange={this.updateUrl} type="text"/>
        <Button className="red-ghost-btn" disabled={!videoURL} onClick={this.onSubmit}>
          Save
        </Button>
      </div>
    );
  };

  componentWillReceiveProps(nextProps) {
    const {identifier} = this.props;
    if (identifier && nextProps.contents) {
      this.setState({
        identifier,
        videoURL: this.state.videoURL || nextProps.contents.body || ''
      });
    }
  }

  componentWillMount() {
    this.setState({
      identifier: this.props.identifier,
      videoURL: this.props.contents ? this.props.contents.body : ''
    });
  }

  render() {
    const {videoURL} = this.state;
    const {editContent} = this.props;

    let $video = null;
    if (videoURL) {
      $video = <iframe allowFullScreen frameBorder="0" height="500" src={videoURL} width="100%"/>;
    } else {
      $video = '';
    }

    return (
      <div className="video-editor">
        {$video}
        {editContent && (
          <div>
            <span className="edit-link">
Edit Video (embed URL)
            </span>
            {this.renderVideoInput()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  editContent: state.viewConfig.editContent
});

export default connect(mapStateToProps)(VideoEditor);



// WEBPACK FOOTER //
// ./src/components/common/editor/video-editor/index.jsx